module.exports = __webpack_public_path__ + "img/Chat.1e6f9c91.png";